export default __webpack_public_path__ + "static/media/CoalGenerator.256.3801792a.png";